import slugify from 'slugify';

export default school => slugify(school)